import React from "react";
import { useNavigate } from "react-router-dom";
import SvgComponent from "../../_utils/SVGComponent";

const arrowDownWhite =
  "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg";
const MultiEntityButton = ({ setOpenAllEntities, openAllEntities, data }) => {
  const navigate = useNavigate();
  return (
    <>
      <button
        className="flex gap-gap-sm items-center py-padding-sm px-padding-md text-font-md font-normal duration-300 ease-in text-text-primary border rounded-md border-text-primary hover:bg-Blue-1-hover"
        onClick={() => {
          setOpenAllEntities(!openAllEntities);
          setTimeout(() => {
            navigate("/multi_entity_viewAll", { state: data });
          }, 100);
        }}
      >
        Add more
        <span>
          <SvgComponent
            color="var(--text-primary)"
            height="var(--icon-xs)"
            width="var(--icon-xs)"
            url={arrowDownWhite}
          />
        </span>
      </button>
    </>
  );
};

export default MultiEntityButton;
